import { SYSTEM_MODES } from "src/stores/slices/createAppSlice";

export const PHONE_NUMBER_ERROR
  = "Invalid phone number. Number should contain digits only, either 11 or 13 characters, including the plus sign (+).";

export const PHONE_NUMBER_CONFLICT_ERROR
  = "This number conflicts with an existing one. Please enter a unique number.";

export const RECEIVE_CALL_SHORTLY = "You should receive a call shortly.";

export const RECEIVE_SMS_SHORTLY = "You should receive a text message shortly.";

export const SHARE_PREVIEW_TOOLTIP_TITLE = "To share your AI agent, please ensure it is live.";

export const INITIATE_CALL_WENT_WRONG
  = "Something went wrong while initiating the call.";

export const INITIATE_SMS_WENT_WRONG
  = "Something went wrong while initiating the text message.";

export const CALL_ME_FIELDS = {
  PHONE_NUMBER: {
    ID: "phoneNumber",
    LABEL: "Phone number",
    PLACEHOLDER: "Enter your phone number",
    ERROR: "Invalid phone number. Please enter a 10-digit US phone number. Dashes and special characters are not supported."
  },
  CALLER_ID: {
    ID: "callerId",
    LABEL: "Caller ID Number",
    PLACEHOLDER: "Enter caller ID Number",
    INSTRUCTIONS: "Enter the phone number you want to be identified as during this call.",
    ERROR: "Invalid phone number. Please enter a 10-digit US phone number. Dashes and special characters are not supported."
  },
  SITES: {
    ID: "site",
    LABEL: "Site",
    PLACEHOLDER: "Select site",
    INSTRUCTIONS: "Choose the clinic or location you want to simulate a call to.",
    ERROR: ""
  },
  OPERATING_HOURS: {
    ID: "businessHoursMode",
    LABEL: "Operating Hours",
    INSTRUCTIONS: "Simulate the call based on configured operating hours.",
    PLACEHOLDER: "Select operating hours mode"
  },
  OUTBOUND_JSON: {
    ID: "outboundJson",
    LABEL: "Task Data",
    INSTRUCTIONS: "Enter a sample JSON with patient and appointment info to simulate the task.",
    PLACEHOLDER: "Enter JSON",
    ERROR: "Invalid JSON format. Please check your input."
  },
  DIALOG_DESCRIPTION: {
    [SYSTEM_MODES.READ_ONLY]: "You're about to preview your agent's main version. Test calls will appear as 'Test' and route to the EHR's non-production environment, with no impact on real data. ",
    [SYSTEM_MODES.EDIT]: "You're about to preview your agent's draft version. Test calls will appear as 'Test' and route to the EHR's non-production environment, with no impact on real data. ",
  }
};
